import React from "react"
import { getThemeStylesheet } from "../../packs/travel_book/avia_v3/utils/filters/build"

const SearchLayout = ({ children, themeName }) => {
  const theme = getThemeStylesheet(themeName)

  return (
    <div data-theme={theme} className="w-full max-w-[1550px] mx-auto">
      {children}
    </div>
  )
}

export default SearchLayout
